import React from 'react';
import Contacts from 'components/Contacts';

const ContactsPage = () => {
  return <Contacts />;
};

export default ContactsPage;
